import { Snackbar, Alert } from "@mui/material";

interface AppSnackbarProps {
    open: any,
    message: string,
    severity: any, // success | error | warning | info
    autoHideDuration: number,
    onClose: any
}

const AppSnackbar = ({
                         open,
                         message,
                         severity, // success | error | warning | info
                         autoHideDuration = 3000,
                         onClose
                     }: AppSnackbarProps) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                sx={{ width: "100%" }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default AppSnackbar;